import { Button } from "@mui/material";
import { BarLineChart } from "components/icons";
import { useUserDataContext } from "context/UserDataContext";
import { useAPIExchangesMetadata } from "hooks/useAPI";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getLocalStorageBooleanValue, isCoinmateGridCurrencyPair } from "utils";

interface IProps {
  id: string;
  currencyPair: string;
}

const CreateGridStrategyButton = ({ id, currencyPair }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { subscriptionPaused } = useUserDataContext();
  const { data: exchangesMetadata } = useAPIExchangesMetadata();
  const isFeatureEnabled = getLocalStorageBooleanValue("featureLinkedDcaBotEnabled", false);

  if (!isFeatureEnabled || !isCoinmateGridCurrencyPair(exchangesMetadata, currencyPair)) return null;

  return (
    <Button
      color="success"
      disableElevation
      disabled={subscriptionPaused}
      fullWidth
      startIcon={<BarLineChart fontSize="inherit" />}
      variant="contained"
      onClick={() => navigate(`/nova-grid-strategie?linkedDcaBotId=${id}`)}>
      {t("dcaBots.createGridStrategy")}
      {"..."}
    </Button>
  );
};

export default CreateGridStrategyButton;
